/**
 * Theme plumbing (U5). The document theme is the `data-theme` attribute on
 * <html> (panel/index.html ships `data-theme="dark"`). U6's zustand theme
 * store should call `setDocumentTheme` and may persist via THEME_STORAGE_KEY.
 * Subtrees can be themed independently by setting `data-theme` on any element
 * (tokens are scoped to `[data-theme]`, not just `:root`).
 */

export type ThemeName = 'dark' | 'light';

export const THEME_STORAGE_KEY = 'buildledger.theme';

export function setDocumentTheme(theme: ThemeName): void {
  document.documentElement.dataset.theme = theme;
}

export function getDocumentTheme(): ThemeName {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

export function readStoredTheme(): ThemeName | null {
  try {
    const raw = window.localStorage.getItem(THEME_STORAGE_KEY);
    return raw === 'light' || raw === 'dark' ? raw : null;
  } catch {
    return null;
  }
}

export function storeTheme(theme: ThemeName): void {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    /* storage unavailable — theme simply won't persist */
  }
}
